import { ElementType } from "react";

/**
 * Currently is only used for the KanbanBoard component
 * @param value
 * @param icon
 * @returns
 */

function CardFooterContent({
  value,
  icon,
}: {
  value: number | undefined;
  icon: ElementType;
}) {
  const Icon = icon;

  if (value) {
    return (
      <div className="aero:flex aero:gap-1 aero:mx-0.5 aero:justify-center">
        {Icon && <Icon className="aero:h-4 aero:w-4 aero:!text-gray-500" />}
        <span className="aero:!text-xs aero:!font-medium aero:!text-zinc-600">
          {value}
        </span>
      </div>
    );
  }

  return <></>;
}

export default CardFooterContent;
